<template>
  <div
    class="card_dragger_wrapper"
    :style="{
      width: wrapperWidth,
      height: wrapperHeight
    }"
  >
    <div
      v-for="d in data"
      class="card_wrapper"
      :key="d.routeName"
      :id="d.routeName"
      :style="{
        width: cardOutsideWidth + 'px',
        height: cardOutsideHeight + 'px'
      }"
      :class="draggable ? 'draggable' : 'disdraggable'"
      @mousedown="handleTouchStart($event, d.routeName)"
      @click="showWarningContent(d)"
    >
      <div
        class="card_item"
        :style="{
          width: cardInsideWidth + 'px',
          height: cardInsideHeight + 'px'
        }"
      >
        <header>
          <div class="title">
            {{ lang === "en" ? d["en-US"] : d["zh-CN"] }}
          </div>
          <a-checkbox
            v-show="draggable"
            v-model="d.hide"
            @mousedown.stop
            @change="handleWarningTypeHiddenStatusChange($event, d.id)"
          />
        </header>
        <div class="count">
          <template v-if="d.routeName === 'DeviceAllWarnings'">
            <span>{{ $t("deviceWarningsCount.title") }}</span>
          </template>
          <template v-else>
            {{ $t("warning.countTitle") }}
            <span style="color: red">
              &nbsp;{{ count[d.id] || 0 }}&nbsp;
            </span>
            {{ lang === "en" ? "warnings" : "条" }}
            <a-button type="link" class="btn" v-show="draggable" @mousedown.stop @click="hideWarningType(d.id)">
              {{ $t("warning.hide_o") }}
            </a-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: []
    },
    cardOutsideWidth: {
      type: Number,
      default: 590
    },
    cardOutsideHeight: {
      type: Number,
      default: 380
    },
    cardInsideWidth:{
      type:Number,
      default:560      
    },
    cardInsideHeight:{
      type:Number,
      default:320      
    },
    colNum: {
      type: Number,
      default: 2
    },
    draggable: {
      type: Boolean,
      default: false
    },
    count: {
      type: Object,
      default: {}
    },
    selectedWarningTypesToDelete: {
      type: Array,
      default: []
    },
    toggleComponent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      wrapperWidth: "0px",
      wrapperHeight: "0px"
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.setWrapperSize()
        this.setCardsPosition()
      })
    }
  },
  methods: {
    /* 尺寸及位置计算 */
    computeTop(n) {
      return (Math.ceil(n / this.colNum) - 1) * this.cardOutsideHeight
    },
    computeLeft(n) {
      return (n - 1) % this.colNum * this.cardOutsideWidth
    },
    setWrapperSize() {
      this.wrapperWidth = this.cardOutsideWidth * this.colNum + "px"
      this.wrapperHeight = this.computeTop(this.data.length) + this.cardOutsideHeight + "px"
    },
    setCardsPosition() {
      let dom, d
      for (let i = 0; i < this.data.length; i++) {
        d = this.data[i]
        dom = document.getElementById(d.routeName)
        if (dom) {
          dom.style.top = this.computeTop(d.positionNum) + "px"
          dom.style.left = this.computeLeft(d.positionNum) + "px"
        }
      }
    },
    /* 拖拽事件 */
    handleTouchStart(e, routeName) {
      if (this.mousedownTimer) {
        return
      }

      if (!this.draggable) {
        return
      }

      const _this = this
      let dectetTimer = null
      let originTop = document.body.scrollTop === 0
        ? document.documentElement.scrollTop
        : document.body.scrollTop
      let scrollTop = originTop
      // 卡片要移动到的位置
      let moveTop = 0, moveLeft = 0
      // 卡片位置
      const cardPosition = {
        left: 0,
        top: 0,
        originNum: -1
      }
      // 鼠标位置
      const mousePosition = {
        x: 0,
        y: 0
      }
      // 要交换的卡片号码
      let oldPositon = null, newPositon = null
      // 选中卡片对应的dom以及数据
      const selectedDom = document.getElementById(routeName)
      const selectedWarningType = this.data.find(d => d.routeName === routeName)

      // 记录鼠标位置
      mousePosition.x = e.screenX
      mousePosition.y = e.screenY

      // 设置移动卡片特殊样式
      selectedDom.classList.add("moveBox")

      // 记录卡片初始位置
      moveTop = cardPosition.top = parseInt(
        selectedDom.style.top.slice(0, -2)
      )
      moveLeft = cardPosition.left = parseInt(
        selectedDom.style.left.slice(0, -2)
      )
      
      document.addEventListener("mousemove", handleMousemove)
      document.addEventListener("mouseup", handleMouseup)

      function handleMousemove(e) {
        /* 卡片跟随鼠标移动 */
        moveTop = cardPosition.top + e.screenY - mousePosition.y
        moveLeft = cardPosition.left + e.screenX - mousePosition.x

        const moveBox = document.querySelector(".moveBox")
        moveBox.style.left = moveLeft + "px"
        // 算上滚动的高度
        moveBox.style.top = moveTop + scrollTop - originTop + "px"

        /* 检测碰撞体积 */
        if (!dectetTimer) {
          dectetTimer = setTimeout(() => {
            detectCard(moveTop + scrollTop - originTop, moveLeft)
            dectetTimer = null
          }, 200)
        }
      }

      function handleMouseup() {
        clearTimeout(dectetTimer)
        dectetTimer = null
        detectCard(moveTop + scrollTop - originTop, moveLeft)

        const moveBox = document.querySelector(".moveBox")
        moveBox.classList.add("transition")
        moveBox.style.top = _this.computeTop(selectedWarningType.positionNum) + "px"
        moveBox.style.left = _this.computeLeft(selectedWarningType.positionNum) + "px"

        _this.mousedownTimer = setTimeout(() => {
          const moveBox = document.querySelector(".moveBox")
          moveBox.classList.remove("moveBox")
          moveBox.classList.remove("transition")
          clearTimeout(_this.mousedownTimer)
          _this.mousedownTimer = null
        }, 300)

        document.removeEventListener("mousemove", handleMousemove)
        document.removeEventListener("mouseup", handleMouseup)
      }

      function detectCard(moveTop, moveLeft) {
        let colNumber = Math.round(moveLeft / _this.cardOutsideWidth) + 1
        let rowNumber = Math.round(moveTop / _this.cardOutsideHeight)

        // 溢出容器边界
        let flag = rowNumber > (Math.ceil(_this.data.length / _this.colNum) - 1)
          || rowNumber < 0
          || colNumber <= 0
          || colNumber > _this.colNum
        if (flag) {
          return
        }

        const newPositionNum = rowNumber * _this.colNum + colNumber
        if (newPositionNum !== selectedWarningType.positionNum) {
          let warningTypeToSwicth = _this.data.find(d => d.positionNum === newPositionNum)
          if (warningTypeToSwicth) {
            switchPosition(warningTypeToSwicth, selectedWarningType)
          }
        }
      }

      function switchPosition(newItem, oldItem) {
        oldPositon = oldItem.positionNum
        newPositon = newItem.positionNum

        let changeArray = [], distance, c

        if (newPositon > oldPositon) {
          // 位置号码小的移动到大的
          distance = -1
          // 小号码空出来，其余卡片往前一位
          for (let i = oldPositon + 1; i <= newPositon; i++) {
            c = _this.data.find(d => d.positionNum === i)
            if (c) {
              changeArray.push(c)
            }
          }
        }

        if (newPositon < oldPositon) {
          distance = 1
          for (let i = oldPositon - 1; i >= newPositon; i--) {
            c = _this.data.find(d => d.positionNum === i)
            if (c) {
              changeArray.push(c)
            }
          }
        }

        for (let c of changeArray) {
          _this.$set(c, "positionNum", c.positionNum + distance)
          const dom = document.getElementById(c.routeName)
          if (dom) {
            dom.style.top = _this.computeTop(c.positionNum) + "px"
            dom.style.left = _this.computeLeft(c.positionNum) + "px"
          }
        }

        _this.$set(oldItem, "positionNum", newPositon)
      }
    },
    /* 预警类型相关事件 */
    hideWarningType(id) {
      this.$emit("removeWarningType", id)
    },
    handleWarningTypeHiddenStatusChange(e, id) {
      const index = this.selectedWarningTypesToDelete.findIndex(s => s === id)

      if (e.target.checked) {
        if (index < 0) {
          this.selectedWarningTypesToDelete.push(id)
        }
      } else {
        if (index >= 0) {
          this.selectedWarningTypesToDelete.splice(index, 1)
        }
      }
    },
    /* 显示预警内容 */
    showWarningContent(type) {
      if (!this.draggable) {
        this.toggleComponent("WarningContent", type, this.data.filter(d => d.routeName !== "DeviceAllWarnings"))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card_dragger_wrapper {
  position: relative;

  .card_wrapper {
    position: absolute;
    transition: all .3s;
    display: flex;
    align-items: center;

    &.draggable {
      cursor: move;
      user-select: none;
    }

    &.disdraggable {
      cursor: pointer;
      user-select: unset;
    }

    &.moveBox {
      z-index: 300;
      transition: none;
    }

    &.transition {
      transition: all .3s;
    }

    .card_item {
      border-radius: 5px;
      box-shadow: 0 0 5px #cacaca;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      header {
        border-bottom: 1px solid #e0e0e0;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #fff;
        background-color: rgb(114, 157, 177);
        padding: 0px 15px;
        position: relative;

        .title {
          width: 100%;
          pointer-events: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        /deep/ .ant-checkbox-wrapper {
          margin-bottom: 0 !important;
        }
      }

      .count {
        width: 100%;
        flex: 1;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .btn {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>